import $ from 'jquery';
export function progressBar() {
  /*
      Scroll Progress Bar
    */
  let $progressBar = $('#scroll_progress_bar');
  $(window).on('scroll', function () {
    let scrollTop = $(window).scrollTop();
    let docHeight = $(document).height() - $(window).height();
    let progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    $progressBar.css('width', progress + '%');
  });
}
